import {ProductPropertiesPane} from '../components/NodePropertiesPane.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Model from './ModelChg.mjs'

export default function PropertiesPaneChg(props) {
    return (
        <ProductPropertiesPane
            controllers={
                <>
                    <Text prop="chgNo" />
                    <Text prop="chgTitle" />
                </>
            }

            Model={Model}
            sn={null}
            {...props}
        />
    )
}
